import React, { useEffect, useState } from "react";
import "./upgradeNow.scss";
import Image from "next/image";
import Link from "next/link";
import template01 from "@/../public/modals/upgrade-now/card-02.webp";
import template02 from "@/../public/modals/upgrade-now/card-03.webp";
import template03 from "@/../public/modals/upgrade-now/card-04.webp";
import template04 from "@/../public/modals/upgrade-now/card-05.webp";
import { allRoutes } from "@/data/allRoutes";
import bg from "@/../public/modals/upgrade-now/bg1.webp";
import closeBtn from "@/../public/modals/upgrade-now/close-btn.png";
const templates = [template01, template02, template03, template04];

export default function UpgradeNowModal({
  setOpenUpgradeNowModal,
  userDataSelector,
}) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % templates.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex-col-center UpgradeNowModal">
      <div className="flex-row-center overlayContainer">
        <Link
          href={userDataSelector ? allRoutes.faceSwap : "/ai-face-swap"}
          // href="/ai-face-swap-photo-enhancer/durga-maa"
        >
          <div className="bgImg">
            <Image src={bg} alt="background" />
          </div>
          <div className="flex-row-center mainContainer">
            <Image
              src={templates[currentIndex]}
              alt={`template-${currentIndex + 1}`}
            />
          </div>
        </Link>
        <div
          onClick={() => setOpenUpgradeNowModal(false)}
          className="flex-row-center closeBtn"
        >
          <Image src={closeBtn} alt="close" />
        </div>
      </div>
    </div>
  );
}
